import React, {useState, useEffect} from 'react';
import {useMutation, useQuery} from '@apollo/client';
import {updateCreate} from '../../utils/mutation';
import {Loading} from '../../components/Query';
import Avatar from '../../components/Avatar';
import Icon from '../../components/Icon';
import {QUERY_THEME_LIST} from '../Theme/graphql';
import {QUERY_USER} from '../Client/graphql';
import {MUTATION_FRIEND_SAVE, QUERY_FRIEND_LIST} from '../Friend/graphql';
import {MUTATION_TALK_TARGET, QUERY_TALK_DETAIL} from './graphql';
import {
  TARGET_DISCUSSING,
  TARGET_NEXT_TOPIC,
  TARGET_NEXT_THEME,
  TARGET_WAITING,
  TARGETS,
  TARGET_QUIT,
  TARGET_NONE,
} from './constants';
import LetterList from '../Letter/List';

const TOPICS = [TARGET_DISCUSSING, TARGET_NEXT_TOPIC, TARGET_NEXT_THEME];

const TalkDetail = ({id}) => {
  const [isQuit, setQuit] = useState(false);
  const [contact, setContact] = useState(null);

  const {user} = useQuery(QUERY_USER).data;

  const query = useQuery(QUERY_TALK_DETAIL, {variables: {id}});
  const obj = query.data ? query.data.talkDetail : null;

  useEffect(() => {
    query.startPolling(3000);

    return () => {
      query.stopPolling();
    };
  }, []);

  const {themeList} = useQuery(QUERY_THEME_LIST).data || {themeList: []};
  const {friendList} = useQuery(QUERY_FRIEND_LIST).data || {friendList: []};

  const [target] = useMutation(MUTATION_TALK_TARGET);
  const [friendSave] = useMutation(MUTATION_FRIEND_SAVE, {
    update: (cache, response) => {
      if (!friend) {
        updateCreate(cache, response, {query: QUERY_FRIEND_LIST});
      }
    },
  });

  if (!obj) {
    return <Loading />;
  }

  const clientNumber = user.client.id === obj.client1.id ? 1 : 2;
  const talkerNumber = user.client.id === obj.client1.id ? 2 : 1;

  const friend = friendList.find(x =>
    [x.client1.id, x.client2 && x.client2.id].includes(obj[`client${talkerNumber}`] && obj[`client${talkerNumber}`].id),
  );
  const theme = themeList.find(x => parseInt(x.id) === obj.themeIds[obj.themeIndex]);

  const isActive = TOPICS.includes(obj.target1) && TOPICS.includes(obj.target2);

  return (
    <div className="TalkDetail py-4">
      <div className="row gx-lg-5 gy-5">
        <div className="col-lg-7">
          <div className="border bg-white rounded p-3 mb-4">
            {obj.client2 && (
              <div>
                <div className="row gx-3 align-items-center">
                  <div className="col-auto">
                    <Avatar user={obj[`client${talkerNumber}`].user} size={50} />
                  </div>
                  <div className="col">
                    <div>{obj[`client${talkerNumber}`].user.fullname}</div>
                    <div className={`font-2 text-${TARGETS[obj[`target${talkerNumber}`]].color}`}>
                      {TARGETS[obj[`target${talkerNumber}`]].label}
                    </div>
                  </div>
                  <div className="col-auto">
                    <div className="row gx-2">
                      {obj[`client${talkerNumber}`].zoom && (
                        <div className="col-auto">
                          <button
                            onClick={() => setContact(contact === `zoom${talkerNumber}` ? null : `zoom${talkerNumber}`)}
                            className="btn btn-sm btn-link p-0"
                          >
                            <Icon name="zoom" size={22} />
                          </button>
                          {contact === `zoom${talkerNumber}` && (
                            <a
                              target="_blank"
                              rel="noreferrer"
                              href={'https://zoom.us/j/' + obj[`client${talkerNumber}`].zoom}
                              className="ms-1 text-primary"
                            >
                              {obj[`client${talkerNumber}`].zoom}
                            </a>
                          )}
                        </div>
                      )}
                      {obj[`client${talkerNumber}`].skype && (
                        <div className="col-auto">
                          <button
                            onClick={() =>
                              setContact(contact === `skype${talkerNumber}` ? null : `skype${talkerNumber}`)
                            }
                            className="btn btn-sm btn-link p-0"
                          >
                            <Icon name="skype" size={22} />
                          </button>
                          {contact === `skype${talkerNumber}` && (
                            <a
                              target="_blank"
                              rel="noreferrer"
                              href={'skype:' + obj[`client${talkerNumber}`].skype + '?call'}
                              className="ms-1 text-primary"
                            >
                              {obj[`client${talkerNumber}`].skype}
                            </a>
                          )}
                        </div>
                      )}
                      {/*{obj[`client${talkerNumber}`].contacts.map(x => (*/}
                      {/*  <div className="col-auto" key={x.id}>*/}
                      {/*    <button*/}
                      {/*      onClick={() => setContact(contact === x.id ? null : x.id)}*/}
                      {/*      className="btn btn-sm btn-link p-0"*/}
                      {/*    >*/}
                      {/*      <Icon name={x.channel.toLowerCase()} size={22} />*/}
                      {/*    </button>*/}
                      {/*    {contact === x.id && <span className="ms-1 text-primary">{x.value}</span>}*/}
                      {/*  </div>*/}
                      {/*))}*/}
                    </div>
                  </div>
                  <div className="row gx-3 mt-2">
                    <div className="col-auto">
                      {friend ? (
                        friend.isAccepted ? (
                          <button disabled className="btn btn-primary">
                            Вы уже друзья
                          </button>
                        ) : (
                          <button
                            onClick={() => friendSave({variables: {input: {friend: obj[`client${talkerNumber}`].id}}})}
                            disabled={friend.client1.id === user.client.id}
                            className={`btn btn-${friend.client1.id === user.client.id ? 'info' : 'primary'}`}
                          >
                            {friend.client1.id === user.client.id
                              ? 'Вы отправили запрос дружбы'
                              : 'Принять запрос дружбы'}
                          </button>
                        )
                      ) : (
                        <button
                          onClick={() => friendSave({variables: {input: {friend: obj[`client${talkerNumber}`].id}}})}
                          className="btn btn-primary"
                        >
                          Отправить запрос на дружбу
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}
            {!obj.client2 && (
              <div className="row align-items-center justify-content-between">
                <div className="col-auto">Поиск собеседника ...</div>
                <div className="col-auto font-2">(Рекомендованное время 20:00-22:00)</div>
              </div>
            )}
          </div>
          <div className="border rounded bg-white p-3">
            <div className="row align-items-center gx-3">
              <div className="col-auto">
                <Avatar user={user} size={50} />
              </div>
              <div className="col">
                <div>{user.fullname}</div>
                {obj[`target${talkerNumber}`] !== TARGET_NONE && (
                  <div className={`font-2 text-${TARGETS[obj[`target${clientNumber}`]].color}`}>
                    {TARGETS[obj[`target${clientNumber}`]].label}
                  </div>
                )}
              </div>
              <div className="col-auto">
                <div className="row gx-2">
                  {obj[`client${clientNumber}`].zoom && (
                    <div className="col-auto">
                      <button
                        onClick={() => setContact(contact === `zoom${clientNumber}` ? null : `zoom${clientNumber}`)}
                        className="btn btn-sm btn-link p-0"
                      >
                        <Icon name="zoom" size={22} />
                      </button>
                      {contact === `zoom${clientNumber}` && (
                        <span className="ms-1 text-primary">{obj[`client${clientNumber}`].zoom}</span>
                      )}
                    </div>
                  )}
                  {obj[`client${clientNumber}`].skype && (
                    <div className="col-auto">
                      <button
                        onClick={() => setContact(contact === `skype${clientNumber}` ? null : `skype${clientNumber}`)}
                        className="btn btn-sm btn-link p-0"
                      >
                        <Icon name="skype" size={22} />
                      </button>
                      {contact === `skype${clientNumber}` && (
                        <span className="ms-1 text-primary">{obj[`client${clientNumber}`].skype}</span>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="row gx-3 mt-2">
              {isQuit ? (
                <>
                  <div className="col-auto">
                    <button
                      onClick={() => target({variables: {input: {id: obj.id, target: TARGET_QUIT}}})}
                      className="btn btn-danger"
                    >
                      Выйти
                    </button>
                  </div>
                  <div className="col-auto">
                    <button onClick={() => setQuit(false)} className="btn btn-light">
                      Отмена
                    </button>
                  </div>
                </>
              ) : (
                <>
                  {obj[`target${clientNumber}`] === TARGET_NONE && (
                    <div className="col-auto">
                      <button
                        onClick={() => target({variables: {input: {id: obj.id, target: TARGET_WAITING}}})}
                        className="btn btn-primary"
                      >
                        Подтвердить
                      </button>
                    </div>
                  )}
                  {obj[`target${clientNumber}`] !== TARGET_NONE && obj[`target${talkerNumber}`] !== TARGET_NONE && (
                    <div className="col-auto">
                      <button
                        onClick={() => target({variables: {input: {id: obj.id, target: TARGET_DISCUSSING}}})}
                        className="btn btn-light"
                      >
                        Начать беседу
                      </button>
                    </div>
                  )}
                  {isActive && obj.topic.order < (theme ? theme.topicsCount : 0) && (
                    <div className="col-auto">
                      <button
                        onClick={() => target({variables: {input: {id: obj.id, target: TARGET_NEXT_TOPIC}}})}
                        className="btn btn-light"
                      >
                        Следующий вопрос
                      </button>
                    </div>
                  )}
                  {isActive && obj.themeIndex + 1 < obj.themeIds.length && (
                    <div className="col-auto">
                      <button
                        onClick={() => target({variables: {input: {id: obj.id, target: TARGET_NEXT_THEME}}})}
                        className="btn btn-light"
                      >
                        Следующяя тема
                      </button>
                    </div>
                  )}
                  <div className="col-auto">
                    <button onClick={() => setQuit(true)} className="btn btn-light">
                      Выйти
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
          <div className="bg-white border rounded p-3 mt-4">
            {obj.themeIds.map((item, index) => {
              const thisTheme = themeList.find(x => parseInt(x.id) === item);

              if (!thisTheme) {
                return null;
              }

              return (
                <span key={item} className={`me-3 ${obj.themeIndex === index ? 'fw-bold' : 'text-muted'}`}>
                  {thisTheme && thisTheme.name} ({thisTheme.topicsCount} вопросов)
                </span>
              );
            })}
            {isActive && (
              <div className="mt-3">
                <span className="fw-bold">№{obj.topic.order}</span>. {obj.topic.name}
              </div>
            )}
          </div>
        </div>
        <div className="col-lg-5 position-relative">
          <div className="position-absolute w-100 bg-white border" style={{height: 'calc(100vh - 105px)'}}>
            <LetterList talkId={obj.id} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TalkDetail;
